export default (config) => {
    config = {
        ...config,
        productAdd: {
            id: 'ID',
            barcode: 'Barcode'
        },
        paymentType: {
            cash: 'Cash',
            card: 'Card'
        },
        deliveryType: {
            delivery: 'Delivery',
            pickup: 'Pickup'
        },
        bannerPlaces: {
            home: 'Home',
            nav: 'Navigation'
        },
        bannerTypes: {
            slider: 'Slider',
            ltext_slider: 'Left text slider',
            single_banner: 'Single banner',
            double_banner: 'Double banners',
            triple_banner: 'Triple banners',
            video: 'Video and banner',
        },
        subType: {
            default: 'Default',
            newin: 'New arrivals',
            sales: 'Sales',
            designers: 'Designers'
        },
        yesNo: {
            true: 'Yes',
            false: 'No',
        },
        gender: {
            '-': '-',
            m: 'Male',
            f: 'Female'
        },
        status: {
            default: {
                on: 'Active',
                off: 'Not active'
            },
            user: {
                on: 'Active',
                off: 'Hidden',
                pending: 'Pending'
            },
            payment: {
                paid: 'Paid',
                error: 'Error',
                new: 'New'
            },
            store: {
                on: 'Active',
                off: 'Hidden',
                pending: 'Pending',
                expired: 'Expired',
                blocked: 'Blocked'
            },
            order: {
                new: 'New',
                waiting_payment: 'Waiting payment',
                payment_canceled: 'Payment canceled',
                waiting_loyalty: 'Waiting loyalty',
                loyalty_canceled: 'Loyalty canceled',
                ready: 'Ready',
                sent: 'Sent',
                completed: 'Completed',
                canceled: 'Canceled',
                returned: 'Returned',
            },
        },
        feedbackType: {
            info: 'Information',
            comment: 'Suggestion or comment'
        },
        month: {
            1: 'January',
            2: 'February',
            3: 'March',
            4: 'April',
            5: 'May',
            6: 'June',
            7: 'July',
            8: 'August',
            9: 'September',
            10: 'October',
            11: 'November',
            12: 'December',
        },
        packageLength: {
            1: '2-3 days',
            2: '4-7 days',
            3: '8-11 days',
            4: '12-15 days',
        },
        packageHotel: {
            1: '3-star hotel',
            2: '4-star hotel',
            3: '5-star hotel'
        },
        feedbackFindUs: {
            fromOffice: "Office in Old City",
            fromHotel: 'Your Hotel',
            fromInternet: "Internet",
            other: 'Other'
        },
        feedbackRecommendUs: {
            yes: "Yes",
            no: 'No'
        }
    }
    return config
}
